"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const recoil_1 = require("recoil");
const settlementGuideDialogState_1 = require("./settlementGuideDialogState");
const react_i18next_1 = require("react-i18next");
const ToggleButtonGroup_1 = __importDefault(require("@mui/material/ToggleButtonGroup"));
const ToggleButton_1 = __importDefault(require("@mui/material/ToggleButton"));
const styled_1 = __importDefault(require("@emotion/styled"));
function default_1() {
    const [guideTabVal, setGuideTabVal] = (0, recoil_1.useRecoilState)(settlementGuideDialogState_1.settlementGuideTabState);
    const { t } = (0, react_i18next_1.useTranslation)();
    const guideTabObjArr = [
        { label: 'settlement_guide_leader', value: 'leader', name: t('작가님') },
        { label: 'settlement_guide_used/transfer', value: 'used/transfer', name: t('중고/양도') },
        { label: 'settlement_guide_reward', value: 'reward', name: t('사비지킴이') },
    ];
    return ((0, jsx_runtime_1.jsx)(SettlementGuideTabTBG, Object.assign({ "aria-label": "settlement_guide_tab", exclusive: true, value: guideTabVal, onChange: (_, val) => {
            if (val !== null) {
                setGuideTabVal(val);
            }
        } }, { children: guideTabObjArr.map((guideTabObj, index) => {
            const { label, value, name } = guideTabObj;
            return ((0, jsx_runtime_1.jsx)(ToggleButton_1.default, Object.assign({ "aria-label": label, value: value, disableRipple: true }, { children: name }), `${label}_${index}`));
        }) })));
}
exports.default = default_1;
const SettlementGuideTabTBG = (0, styled_1.default)(ToggleButtonGroup_1.default) `
  display: flex;
  column-gap: 20px;
  padding: 0 20px;
  border-radius: 0;
  .MuiToggleButton-root {
    flex-shrink: 0;
    padding: 0;
    border-radius: 0;
    border: 0 !important;
    line-height: 30px;
    font-size: 20px;
    font-weight: bold;
    background-color: transparent !important;
    color: var(--gray-30);
    &.Mui-selected {
      color: var(--gray-80) !important;
    }
  }
`;
